import React from 'react';
import { FormattedNumber } from 'react-intl';
import { isNumber } from 'lodash';

const Currency = ({ value, ...props }) => {
  return !isNumber(value) ? '' : <FormattedNumber value={value} style="currency" currency="USD" {...props} />;
};

export default Currency;
